<!--登录保护-->
<template>
  <div class="protection-container" :style="'min-height:'+min_height+'px;'">
    <div class="protection-content">
      <p class="title SourceHanSansCN">登录保护</p>
      <p class="normal-info SourceHanSansCN">通过技术分析风险因素，多重保护账户安全</p>
      <div class="protection-line">
        <div class="left_side">
          <div class="side-block SourceHanSansCN">异地登录</div>
          <div class="side-light-block SourceHanSansCN">异地登录时验证身份，防止异地盗号</div>
        </div>
        <div class="right_side">
          <el-switch v-model="loginDataStatus.remoteLogin" :width="60" class="switch" @change="statusChange"></el-switch>
        </div>
      </div>
      <div class="protection-line">
        <div class="left_side">
          <div class="side-block SourceHanSansCN">网页登录</div>
          <div class="side-light-block SourceHanSansCN">网页登录时验证身份，防止缓存信息被盗</div>
        </div>
        <div class="right_side">
          <el-switch v-model="loginDataStatus.webLogin" :width="60" class="switch" @change="statusChange"></el-switch>
        </div>
      </div>
      <div class="protection-line">
        <div class="left_side">
          <div class="side-block SourceHanSansCN">用户名登录</div>
          <div class="side-light-block SourceHanSansCN">用户名登录时验证身份，防止密码泄露</div>
        </div>
        <div class="right_side">
          <el-switch v-model="loginDataStatus.usernameLogin" :width="60" class="switch" @change="statusChange"></el-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {loginProtectionStatus,updLoginProtection} from '@/api/currencyApi'
export default {
  name: "loginProtection",
  data() {
    return {
      min_height: document.documentElement.clientHeight - 346,
      remoteLogin:false,
      webLogin:false,
      usernameLogin:false,
      userId:'',
      uid:0,
      loginStatus:{},
      loginDataStatus:{}
    }
  },
  methods:{
    statusChange(){
      let saveData=JSON.parse(JSON.stringify(this.loginDataStatus));
      saveData.remoteLogin=this.loginDataStatus.remoteLogin ? 1 : 0;
      saveData.usernameLogin=this.loginDataStatus.usernameLogin ? 1 : 0;
      saveData.webLogin=this.loginDataStatus.webLogin ? 1 : 0;
      updLoginProtection(saveData).then(res=>{
        if (res.code==200){
          this.$message.success(res.msg);
          this.getLoginProtectionStatus();
        }
      })
    },
    getLoginProtectionStatus(){
      loginProtectionStatus({userId:this.uid,request: 'form'}).then(res=>{
        if (res.code==200){
          this.loginStatus=res.content.entity;
          this.loginDataStatus= {
            remoteLogin:this.loginStatus.remoteLogin==1 ? true : false,
            webLogin:this.loginStatus.webLogin==1 ? true : false,
            usernameLogin:this.loginStatus.usernameLogin==1 ? true : false,
            userId:this.uid,
            uid: this.uid,
            request: "form",
            id:this.loginStatus.id
          }
        }
      })
    }
  },
  mounted() {
    this.getLoginProtectionStatus();
  },
  beforeMount() {
    this.uid=JSON.parse(sessionStorage.getItem('loginData')).cid;
  }
}
</script>
<style scoped>
.protection-container >>> .el-switch__core{
  height: 25px;
  border-radius: 12.5px;
}
.protection-container >>> .el-switch__core:after {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  top: 2px;
  left: 3px;
}
.protection-container .is-checked >>>  .el-switch__core::after {
  left: 53px !important;
}
</style>
<style scoped lang="scss">
.protection-container {
  background: #ffffff;

  .protection-content {
    padding: 25px 25px 0px;
    .title{
      font-size: 18px;
      color: #333333;
      margin-block-start: 0px;
      margin-block-end: 0px;
      margin-bottom: 5px;
    }
    .normal-info{
      color: #666666;
      font-size: 14px;
      margin-block-start:0px;
      margin-bottom: 30px;
    }
    .protection-line{
      width: 500px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 30px;
      .side-block{
        font-size: 16px;
        color: #333333;
      }
      .side-light-block{
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>